import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';

import { Button } from '~/shadcn/components/ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '~/shadcn/components/ui/DropdownMenu';

/**
 * Table column dropdown menu with various sorting options.
 *
 * @param {Object} props
 * @param {boolean} props.active - Whether this column is currently being sorted
 * @param {('asc'|'desc')} props.direction - Current sort direction when active
 * @param {string} props.label - Display label for the sort dropdown trigger
 * @param {Function} props.onSort - Callback function when sort option is selected
 * @param {string} props.sortKey - Key identifier for the sortable column
 * @returns {React.ReactElement} A dropdown menu component for table column sorting
 */
function TableSortDropdown({ active, direction, label, onSort, sortKey }) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    size="sm"
                    type="button"
                    className="-ml-3 data-[state=open]:bg-primary/5 data-[state=open]:text-accent-foreground hover:bg-primary/5"
                >
                    {label}
                    {active && direction === 'asc' && <ArrowUp className="h-4 w-4 stroke-1" />}
                    {active && direction === 'desc' && <ArrowDown className="h-4 w-4 stroke-1" />}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start">
                <DropdownMenuItem onClick={() => onSort(sortKey, 'asc')}>
                    <ArrowUp className="h-4 w-4 stroke-1" />
                    Asc
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => onSort(sortKey, 'desc')}>
                    <ArrowDown className="h-4 w-4 stroke-1" />
                    Desc
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => onSort(null, null)}>
                    <ChevronsUpDown className="h-4 w-4 stroke-2" />
                    Unsort
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

export default TableSortDropdown;
